import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let CTitle = class CTitle extends Vue {
    render(h) {
        return h("a-rate", { props: {
                disabled: true,
                count: this.control.options.count
            } });
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], CTitle.prototype, "control", void 0);
CTitle = tslib_1.__decorate([
    Component({ name: 'CTitle' })
], CTitle);
export default CTitle;
